module.exports = __webpack_public_path__ + "img/Menu-13.32e491f2.webp";